// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import GlobalStyles from '../../../../../../../../config/styles';

const styles = theme => ({
  container: {
    width: '100%',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    marginLeft: 14,
    marginRight: 14,
    borderRadius: 16,
    padding: '16px 8px 12px',

    [theme.breakpoints.down(549)]: {
      margin: '5px 0',
    },
  },
  text: {
    marginBottom: 8,
    textAlign: 'center',
    fontSize: GlobalStyles.fonts.FONT_SIZE_MAX,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREEN,
  },
  descText: {
    margin: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GRAY,
  }
});

export default styles;
